module.exports = __webpack_public_path__ + "img/prepaid20-en.3b286e7e.svg";